export default "__VITE_ASSET__DHx7fgcV__"